<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <unit-switch :default-unit-prop.sync="unitProp" @change="onUnitPropChange" />

        <el-radio-group v-model="chartType" size="small">
          <el-radio-button label="bar">柱状图</el-radio-button>
          <el-radio-button label="line">面积图</el-radio-button>
        </el-radio-group>

        <stack-type :stack-type.sync="stackType" @change="isShowBarChange" />

        <el-checkbox
          border
          size="small"
          label="显示饼图"
          v-if="stackType === 2"
          v-model="isShowBar"
          style="margin-left: .5em;"
          @change="isShowBarChange"
        />
      </template>

      <div
        v-for="(data, index) in dataList"
        :key="data.id"
        :style="{
          'height': '100%',
          'display': 'grid',
          'grid-template-columns': `${stackType === 2 && isShowBar  ? 'auto 45%' : '100%'}`,
          'grid-template-rows': '100%',
          'flex': '1 0 100%'
        }"
      >
        <x-y-chart
          ref="xyChart"
          :index="index"
          :data-config="data"
          :unit-prop="unitProp"
          :chart-type="chartType"
          :stack-type="stackType"
          :is-show-bar="isShowBar"
          :download-name="downloadName"
          chart-min-height="400px"
          chart-height="auto"
          need-resize
          selected-change-with-data-changed
          :click-handler="setHighChartOpt"
        />
        <div
          v-if="isShowBar && stackType === 2"
          :style="{
            'max-width': '100%',
            'max-height': '100%',
            'display': 'grid',
            'grid-template-columns': '100%',
            'grid-template-rows': 'max-content 30px auto',
            'grid-row-gap': '10px'
          }"
        >
          <div style="display: flex; justify-content: center;">
            <el-radio-group v-model="showHighChart[index].chartType" size="small" @change="isShow2D3DChange(index)">
              <el-radio-button :label="2">2D</el-radio-button>
              <el-radio-button :label="3">3D</el-radio-button>
            </el-radio-group>
          </div>

          <div style="display: flex; justify-content: center;">
            <el-select
              size="small"
              v-model="showHighChart[index].chartTime"
              style="width: 180px;"
              @change="renderPeriodChart(index)"
            >
              <el-option
                v-for="item in showHighChart[index].period"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
            <el-checkbox
              border
              size="small"
              label="显示均值"
              v-model="showHighChart[index].isShowAvg"
              style="margin-left: .5em;"
              @change="isShowAvgBarChange(index, ...arguments)"
            />
          </div>

          <div
            ref="highChart"
            style="width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;"
          ></div>
        </div>
      </div>
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import UnitSwitch from '../../../../components/Data/UnitSwitch'
import StackType from '../../../../components/Data/StackType'
import XYChart from '../../../../components/DataChart/XYChart'
import Highcharts from 'highcharts'
import highcharts3d from 'highcharts/highcharts-3d'
import exporting from 'highcharts/modules/exporting'

exporting(Highcharts)
highcharts3d(Highcharts)

export default {
  name: 'DataDisplayOCEC',
  routeInfo: {
    label: 'OC/EC',
    icon: 'fa fa-users'
  },
  extends: BaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, CompletedQuery, DataWrapper, UnitSwitch, StackType, XYChart},
  data: () => ({
    query: {
      factorIds: [],
      isMultipleIntegral: true
    },
    chartType: 'bar',
    stackType: 1,
    showHighChart: [],
    highChartTimeOpt: [],
    isShowBar: true
  }),
  computed: {
    siteDeviceCategoryConfig: () => [
      new DeviceCategoryConfig(process.env.OCEC_DEVICE_CATEGORY, true)
    ],
    downloadName: () => 'OC-EC',
    colors () {
      return [
        '#3ba272',
        '#F44336',
        '#7E57C2',
        '#29B6F6',
        '#26A69A',
        '#8BC34A',
        '#FFEE58',
        '#FF9800',
        '#607D8B',
        '#795548',
        '#EC407A',
        '#AB47BC',
        '#26C6DA',
        '#fe7300',
        '#66BB6A',
        '#D4E157',
        '#FFCA28'
      ]
    }
  },
  methods: {
    setAvgHighChartOpt (index) {
      let {chartType, avgHightChartData} = this.showHighChart[index]
      let data = avgHightChartData.map(el => {
        return {
          name: el.name,
          selected: true,
          sliced: true,
          y: el.value,
          value: el.value
        }
      })

      setTimeout(() => {
        this.showHighChart[index].highChart = Highcharts.chart(this.$refs['highChart'][index], {
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            type: 'pie',
            options3d: {
              enabled: chartType === 3,
              alpha: 45,
              beta: 0
            }
          },
          title: {
            text: '',
            style: {
              fontWeight: 'bold'
            }
          },
          legend: {
            align: 'center',
            verticalAlign: 'top',
            x: 0,
            y: 20
          },
          colors: this.colors,
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.2f}%</b>'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              size: '65%',
              depth: chartType === 3 ? 35 : 0,
              dataLabels: {
                enabled: true,
                distance: '15%',
                format: '<b>{point.name}</b>: <br /></b>{point.percentage:.2f} %',
                style: {
                  color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                }
              }
            }
          },
          exporting: {
            enabled: true
          },
          lang: {
            contextButtonTitle: '菜单',
            viewFullscreen: '全屏',
            exitFullscreen: '退出全屏',
            printChart: '打印图表',
            downloadPNG: '下载PNG图片',
            downloadJPEG: '下载JPEG图片',
            downloadPDF: '下载PDF文件',
            downloadSVG: '下载SVG图片'
          },
          series: [{
            name: '平均值',
            opacity: 0.9,
            showInLegend: true,
            data: data
          }]
        })
      }, 100)
    },
    renderPeriodChart (i) {
      let {param, opt, chartTime} = this.showHighChart[i]
      if (param === null) {
        this.showHighChart[i].isShowAvg = false
        this.isShowAvgBarChange(i, false)
      } else {
        this.setHighChartOpt(param, opt, chartTime)
      }
    },
    setHighChartOpt (param, opt, chartTime) {
      /**
       * name 被点击的柱子的时段
       * dataIndex 数据下标
       * series 所有数据
       * legend 图例数据
       * index 图表下标
       * xAxis 时间轴数据
       */
      let {dataIndex, name} = param
      let {series, legend, index, xAxis} = opt
      // 图例是否启用
      let selected = legend[0].selected
      let highChartData = this.showHighChart[index]
      // 获取当前选择时段的下标
      let i = !chartTime ? dataIndex : xAxis[0].data.findIndex(time => time === chartTime)
      if (this.stackType === 2) {
        // 取消显示均值
        this.showHighChart[index].isShowAvg = false
        // 设置当前BarChart数据时间
        this.showHighChart[index].chartTime = name
        // 更新数据
        this.showHighChart[index] = Object.assign(this.showHighChart[index], {
          param: param,
          opt: opt
        })
        // 饼图类型
        let {chartType} = highChartData

        let data = series.map(el => {
          if (selected[el.name]) {
            return {
              name: el.name,
              data: el.data[i] ? el.data[i] : {value: '--', isHaveIntegral: false}
            }
          }
        }).filter(el => el && el.data.value !== '--')

        setTimeout(() => {
          this.showHighChart[index].highChart = Highcharts.chart(this.$refs['highChart'][index], {
            chart: {
              plotBackgroundColor: null,
              plotBorderWidth: null,
              type: 'pie',
              options3d: {
                enabled: chartType === 3,
                alpha: 45,
                beta: 0
              }
            },
            title: {
              text: '',
              style: {
                fontWeight: 'bold'
              }
            },
            legend: {
              align: 'center',
              verticalAlign: 'top',
              x: 0,
              y: 20
            },
            colors: this.colors,
            tooltip: {
              pointFormat: '{series.name}: <b>{point.percentage:.2f}%</b>'
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                size: '65%',
                depth: chartType === 3 ? 35 : 0,
                dataLabels: {
                  enabled: true,
                  distance: '15%',
                  format: '<b>{point.name}</b>: <br /></b>{point.percentage:.2f} %',
                  style: {
                    color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                  }
                }
              }
            },
            exporting: {
              enabled: true
            },
            lang: {
              contextButtonTitle: '菜单',
              viewFullscreen: '全屏',
              exitFullscreen: '退出全屏',
              printChart: '打印图表',
              downloadPNG: '下载PNG图片',
              downloadJPEG: '下载JPEG图片',
              downloadPDF: '下载PDF文件',
              downloadSVG: '下载SVG图片'
            },
            series: [{
              name: name,
              opacity: 0.9,
              showInLegend: true,
              data: data.map(el => {
                return {
                  y: el.data.value,
                  ...el.data,
                  name: el.name,
                  sliced: true,
                  selected: true
                }
              })
            }]
          })
        }, 100)
      }
    },
    isShowBarChange () {
      if (this.stackType === 2 && this.isShowBar) {
        setTimeout(() => {
          let highChart = this.$refs.highChart
          if (highChart && highChart.length > 0) {
            highChart.forEach((item, i) => {
              if (this.showHighChart[i].isShowAvg) {
                this.setAvgHighChartOpt(i)
              } else {
                this.isShowAvgBarChange(i, false)
              }
            })
          }
        }, 10)
      }
    },
    isShowAvgBarChange (i, isShow) {
      let data = this.showHighChart[i]
      if (isShow) {
        this.setAvgHighChartOpt(i)
      } else if (!isShow && data.param !== null) {
        let {param, opt, chartTime} = this.showHighChart[i]
        this.setHighChartOpt(param, opt, chartTime)
      } else if (!isShow && data.param === null) {
        let {periodData, chartType} = this.showHighChart[i]
        let {seriesMap, dimensions, dataTimes} = periodData
        let tempSeries = dataTimes[dataTimes.length - 1][1]
        let chartTime = this.showHighChart[i].chartTime === '' ? tempSeries : this.showHighChart[i].chartTime
        // 设置 当前barChart时间
        this.showHighChart[i].chartTime = chartTime
        let series = []
        let sum = 0

        dimensions.forEach(el => {
          if (el.name !== 'TC') {
            series.push({
              name: el.name,
              value: seriesMap[el.id] && seriesMap[el.id][chartTime] ? seriesMap[el.id][chartTime].value : 0
            })
            sum += seriesMap[el.id] && seriesMap[el.id][chartTime] ? seriesMap[el.id][chartTime].value : 0
          }
        })

        setTimeout(() => {
          this.showHighChart[i].highChart = Highcharts.chart(this.$refs['highChart'][i], {
            chart: {
              plotBackgroundColor: null,
              plotBorderWidth: null,
              type: 'pie',
              options3d: {
                enabled: chartType === 3,
                alpha: 45,
                beta: 0
              }
            },
            title: {
              text: '',
              style: {
                fontWeight: 'bold'
              }
            },
            legend: {
              align: 'center',
              verticalAlign: 'top',
              x: 0,
              y: 20
            },
            colors: this.colors,
            tooltip: {
              pointFormat: '{series.name}: <b>{point.percentage:.2f}%</b>'
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                size: '65%',
                depth: chartType === 3 ? 35 : 0,
                dataLabels: {
                  enabled: true,
                  distance: '15%',
                  format: '<b>{point.name}</b>: <br /></b>{point.percentage:.2f} %',
                  style: {
                    color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                  }
                }
              }
            },
            exporting: {
              enabled: true
            },
            lang: {
              contextButtonTitle: '菜单',
              viewFullscreen: '全屏',
              exitFullscreen: '退出全屏',
              printChart: '打印图表',
              downloadPNG: '下载PNG图片',
              downloadJPEG: '下载JPEG图片',
              downloadPDF: '下载PDF文件',
              downloadSVG: '下载SVG图片'
            },
            series: [{
              name: chartTime,
              opacity: 0.9,
              showInLegend: true,
              data: series.map(el => {
                return {
                  name: el.name,
                  selected: true,
                  sliced: true,
                  value: Number((el.value / sum * 100).toFixed(2)),
                  y: Number((el.value / sum * 100).toFixed(2))
                }
              })
            }]
          })
        }, 100)
      }
    },
    isShow2D3DChange (i) {
      let highChart = this.$refs.highChart
      if (highChart && highChart.length > 0) {
        if (this.showHighChart[i].isShowAvg) {
          this.setAvgHighChartOpt(i)
        } else {
          this.isShowAvgBarChange(i, false)
        }
      }
    },
    setDataList (dataList) {
      this.tmpList = Object.freeze(dataList)
      this.formatData()
      this.setHighChartData()
    },
    setHighChartData () {
      let tempAvg = this.dataList.map(el => {
        let series = []
        let total = el.dataTimes.map(time => time[0]).length
        el.dimensions.forEach(item => {
          if (item.seriesParam.type === 'bar') {
            let sum = Object.values(el.seriesMap[item.id]).reduce((sum, val) => {
              sum += val.value
              return sum
            }, 0)
            series.push({
              name: item.name,
              sum: sum,
              total: total,
              avg: sum / total
            })
          }
        })

        return series
      })
      let period = this.dataList.map(el => el.dataTimes.map(time => {
        return {
          name: time[1],
          value: time[1]
        }
      }))

      let avgHightChartData = tempAvg.map(el => {
        let ratio = []

        let tempTotal = el.reduce((sum, val) => {
          sum += val.avg
          return sum
        }, 0)

        el.forEach(item => {
          ratio.push({
            name: item.name,
            value: Number((item.avg / tempTotal * 100).toFixed(4))
          })
        })
        return ratio
      })

      this.showHighChart = this.dataList.map((el, i) => {
        return {
          id: 0,
          // 是否显示时段barChart
          isShow: false,
          chartType: 2,
          // 时段Opt
          period: period[i],
          // 当前时段
          chartTime: '',
          // 时段bar 数据
          param: null,
          opt: null,
          // 时段BarChart
          highChart: null,
          // 时段BarChartData
          periodData: this.dataList[i],
          // 是否显示均值BarChart
          isShowAvg: true,
          // 均值BarChart
          avgHightChart: null,
          // 均值BarChartData
          avgHightChartData: avgHightChartData[i]
        }
      })

      this.$nextTick(() => {
        this.isShowBarChange()
      })
    },
    onUnitPropChange () {
      this.formatData()
      this.setHighChartData()
    },
    getSeriesParam (dimension, dimensionIds) {
      let siteId = dimensionIds[dimension]
      let factorId = dimensionIds[dimension ^ 1]

      if (factorId === '6404') {
        return {
          type: 'line',
          showSymbol: false
        }
      } else {
        let param = {
          stack: siteId,
          barMaxWidth: 30,
          showSymbol: false,
          areaStyle: {}
        }

        Object.defineProperty(param, 'type', {
          get: () => this.chartType,
          enumerable: true
        })

        return param
      }
    },
    getSelectedNames (dimension, params) {
      return dimension === 0 ? Object.values(params[dimension ^ 1]).reduce((map, config) => {
        map[config.name] = /^640(0|1|4)$/.test(config.id)

        return map
      }, {}) : null
    }
  },
  watch: {
    filterFactorMap: {
      immediate: true,
      handler (filterFactorMap) {
        this.selectedNames = this.query.factorIds.reduce((list, factorId) => {
          if (/^640(0|1|4)$/.test(factorId)) {
            let factor = filterFactorMap[factorId]

            if (factor) {
              list.push(factor.name)
            }
          }

          return list
        }, [])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/03Data-Display/01PM/01OCEC/index.vue